import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useActivityUIContext } from "../ActivityUIContext";
import { fetchActivities } from "../../../actions/activity/activity";

export function ActivityTable() {

  const [loader, setLoader] = useState(true);

  const { activities, totalSize } = useSelector(
    (state) => ({
      activities:
        state.activities.activities && state.activities.activities.docs,
      totalSize: state.activities.activities && state.activities.activities.totalDocs
    }),
    shallowEqual
  );

  console.log("activities", activities)

  const dispatch = useDispatch();

  const activityUIContext = useActivityUIContext();
  const activityUIProps = useMemo(() => {
    return {

      queryParams: activityUIContext.queryParams,
      setQueryParams: activityUIContext.setQueryParams,
    };
  }, [activityUIContext]);

  const [searchQuery, setSearchQuery] = useState('');

  const handleOnChange = (e) => {
    setSearchQuery(e.target.value)
    activityUIProps.setQueryParams((prev) => { return { ...prev, search: e.target.value } })
  }


  async function getActivityData() {
    setLoader(true);
    await dispatch(fetchActivities(activityUIProps.queryParams));
    setLoader(false);
  }

  useEffect(() => {
    getActivityData();
  }, [dispatch, activityUIProps.queryParams]);

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },


    {
      dataField: "created_at",
      text: " Created At",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.CreateDateColumnFormatter,
      style: {
        minWidth: "100px",
      },
    },

  ];

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
    sizePerPage: activityUIProps.queryParams.pageSize,
    page: activityUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
                <div className="col-12">
                  <div class="form-group input-icon" >
                    <input type="email" class="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search here"></input> <span>
                      <i className="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                </div>

              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                // data={[]}
                data={activities === null ? [] : activities}
                onTableChange={getHandlerTableChange(
                  activityUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => activities === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader && <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}